export default {
  orders: 'Objednávky',
  allOrders: 'Všetky objednávky',
  onlyInJobReports: 'Diely sa uvádzajú iba v reportoch jednej vsázky.',
};
